<ng-container *ngIf="!isNewEDPScoreboard; else pairgame">
    <div class="main-score" [ngClass]="{ 'penalties': vm.showPenalties, 'second-half': vm.isSecondHalf }">
        <div class="score-wrapper">
            <ng-container *ngTemplateOutlet="score" />
            <div class="event-score penalty-shootout-points" *ngIf="vm.showPenalties">
                <ms-score-card
                    [eventId]="event.id"
                    [participant1Score]="vm.penalties[0].points.toString()"
                    [participant2Score]="vm.penalties[1].points.toString()" />
            </div>

            <ng-container *ngTemplateOutlet="eventtime" />

            <div class="regular-time" *ngIf="vm.regularTime && !vm.showPenalties">
                <span>{{ sitecoreEventDetails.eventDetails.FinalTime }}</span>
                <span class="regular-time-score">{{ vm.regularTime?.participant1 }} :{{ vm.regularTime?.participant2 }}</span>
                <span>-</span>
                <span>{{ sitecoreEventDetails.eventDetails.ShortOvertime }}</span>
                <span class="over-time-score">{{ vm.overTime?.participant1 }}:{{ vm.overTime?.participant2 }}</span>
            </div>

            <div class="first-half-score" *ngIf="vm.firstHalfScore">
                (<span>{{ sitecoreEventDetails.eventDetails.HalfTime }}</span>
                <span class="regular-time-score">{{ vm.firstHalfScore.participant1 }} - {{ vm.firstHalfScore.participant2 }}</span
                >)
            </div>
        </div>

        <ng-container *ngTemplateOutlet="participants" />
    </div>
    <ms-event-timer
        class="penalty-shootout-text"
        *ngIf="vm.showPenalties"
        [live]="event.live"
        [start]="event.startDate"
        [scoreboard]="event.scoreboard" />
    <ng-container *ngTemplateOutlet="penalty" />
</ng-container>

<ng-template #pairgame>
    <div class="main-score" [ngClass]="{ 'penalties': vm.showPenalties, 'second-half': vm.isSecondHalf }">
        <div class="event-header-live">
            <i class="live-icon"></i>
            <ng-container *ngIf="!vm.showPenalties; else periodname">
                <ng-container *ngTemplateOutlet="eventtime" />
            </ng-container>
        </div>
        <ng-container *ngTemplateOutlet="participants" />
        <ng-container *ngIf="!isNewEDPScoreboard">
            <ng-container *ngTemplateOutlet="penalty" />
        </ng-container>
    </div>

    <ng-container *ngTemplateOutlet="score" />
</ng-template>

<ng-template #participants>
    <ng-container *ngFor="let participant of event.participants; let i = index">
        <div class="participant-details">
            <ms-pair-game-participant
                [event]="event"
                [participant]="participant"
                [sportId]="event.sport.id"
                [redCardsCount]="vm.redCards ? vm.redCards[i] : 0"
                [showLogoColor]="showLogoColor"
                [isNewEDPScoreboard]="isNewEDPScoreboard" />
            <ng-container *ngIf="isNewEDPScoreboard">
                <div class="penalty-shootout-score" *ngIf="vm.showPenalties">
                    <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[i]" />
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #penalty>
    <div class="penalty-shootout-score" *ngIf="vm.showPenalties">
        <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[0]" />
        <ng-container *ngIf="!isNewEDPScoreboard">
            <div class="event-score">
                <ms-score-card
                    [eventId]="event.id"
                    [participant1Score]="vm.penalties[0].points.toString()"
                    [participant2Score]="vm.penalties[1].points.toString()" />
            </div>
        </ng-container>
        <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[1]" />
    </div>
</ng-template>

<ng-template #score>
    <div class="event-score" [ngClass]="{ inactive: (vm.showPenalties && !isNewEDPScoreboard) || vm.isSuspended }">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="vm.score.participant1.toString()"
            [participant2Score]="vm.score.participant2.toString()"
            [showSeparator]="!isNewEDPScoreboard" />
    </div>
</ng-template>

<ng-template #eventtime>
    <div class="event-time">
        <ms-event-timer
            [ngClass]="{ 'event-timer-penalty': vm.showPenalties }"
            [live]="event.live"
            [start]="event.startDate"
            [scoreboard]="event.scoreboard" />
        <span class="after-extra-time" *ngIf="vm.showPenalties">{{ sitecoreEventDetails.eventDetails.AfterExtraTime }}</span>
    </div>
</ng-template>

<ng-template #periodname>
    <span class="period-name">{{ event.scoreboard.period?.name }}</span>
</ng-template>
